import { ColorOption } from "./color-picker.types";

export type PaginationPosition =
  | "bottomRight"
  | "bottomLeft"
  | "bottomCenter"
  | "topRight"
  | "topLeft"
  | "topCenter";
export type PaginationStartOption = "firstPage" | "afterExhibitList";
export type DividerTabTextSize = "small" | "normal" | "large";

export interface PacketConfig {
  packetName: string;
  divider: {
    enabled: boolean;
    mainGroupEnabled: boolean;
    categoryEnabled: boolean;
    documentEnabled: boolean;
    color: string;
    textSize: DividerTabTextSize;
  };
  pagination: {
    enabled: boolean;
    position: PaginationPosition;
    startOn: PaginationStartOption;
    includePageNumbersOnDividers: boolean;
  };
}

export const defaultColors: ColorOption[] = [
  {
    name: "White",
    value: "#FFFFFF",
    isDefault: true
  },
  {
    name: "Current Blue",
    value: "#4A90E2",
    isDefault: true
  },
  {
    name: "Gray",
    value: "#808080",
    isDefault: true
  },
  {
    name: "Pink",
    value: "#FF69B4",
    isDefault: true
  },
  {
    name: "Green",
    value: "#32CD32",
    isDefault: true
  },
  {
    name: "Yellow",
    value: "#FFD700",
    isDefault: true
  },
  {
    name: "Orange",
    value: "#FF8C00",
    isDefault: true
  }
];

export const dividerTabTextSizeOptions: {
  label: string;
  value: DividerTabTextSize;
}[] = [
  { label: "Small", value: "small" },
  { label: "Normal", value: "normal" },
  { label: "Large", value: "large" }
];

// Pagination position options
export const paginationPositions: {
  label: string;
  value: PaginationPosition;
}[] = [
  { label: "Bottom Right", value: "bottomRight" },
  { label: "Bottom Left", value: "bottomLeft" },
  { label: "Bottom Center", value: "bottomCenter" },
  { label: "Top Right", value: "topRight" },
  { label: "Top Left", value: "topLeft" },
  { label: "Top Center", value: "topCenter" }
];

// Start pagination options
export const startPaginationOptions: {
  label: string;
  value: PaginationStartOption;
}[] = [
  { label: "First Page", value: "firstPage" },
  { label: "After Exhibit List", value: "afterExhibitList" }
];
